<template>
  <el-form :model="simpleForm" :rules="rules" ref="simpleForm" label-width="120px" class="demo-ruleForm" label-position="top">
    <el-form-item :label="$t('feed.settings.common.commonSimpleForm.name')" prop="name">
      <el-input v-model="simpleForm.name"></el-input>
    </el-form-item>

    <el-form-item prop="show_at_map">
      <el-checkbox label="Показывать на карте" v-model="simpleForm.show_at_map" v-if="isAdmin"></el-checkbox>
      <el-checkbox label="Точное совпадение" v-model="simpleForm.is_strict"></el-checkbox>
      <!--
      <el-checkbox label="Точное совпадение со склонениями"  v-if="approxyFilter && !changeFilter" :value="approxyFilter" @change="saveSettings(1), changeFilter = true"></el-checkbox>
      <el-checkbox label="Точное совпадение со склонениями" :disabled="emptyFilter" v-if="changeFilter || !approxyFilter" :value="approxFilter" @change="saveSettings(2), changeFilter = true, approxyFilter = $event"></el-checkbox>
    -->
    </el-form-item>

    <el-form-item v-if="!simpleForm.save_for_api">
      <div>Для отправки ленты в ИАО сначала выберите ответственного пользователя:</div>
      <el-checkbox :disabled="newUsers.length != null" :label="'Отправить в ИС ИАО на пользователя ' + `${newUsers.length == null ? newUsers.username : '' }`" v-model="simpleForm.save_for_api"></el-checkbox>
      {{'  '}}
      <el-select filterable v-model="newUsers" placeholder="Выбрать пользователя ИС ИАО:">
        <el-option
          v-for="user in changeUsers"
          :key="user.id"
          :label="user.username"
          :value="user"
          :disabled="user.disabled">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item v-if="simpleForm.save_for_api">
      <el-checkbox :disabled="newUsers.length != null" label="Лента ИС ИАО" v-model="simpleForm.save_for_api"></el-checkbox>
    </el-form-item>

    <el-form-item label="Выводить в ленту сообщения из" prop="social" v-if="isKeyWordType">
      <el-checkbox-group v-model="simpleForm.social">
        <el-checkbox v-for="item in social" :label="item.name" :key="item.id">{{item.label}}</el-checkbox>
      </el-checkbox-group>


    </el-form-item>

    <!--<el-form-item label="Пользователи" prop="users">
      <el-button v-if="!displayUsers" size="small"  @click="() => displayUsers=true"><i class="el-icon-arrow-down"></i></el-button>
      <el-button v-if="displayUsers" size="small" @click="() => displayUsers=false"><i class="el-icon-arrow-up"></i></el-button>
      <el-checkbox-group v-model="usersForm.all" v-if="displayUsers">
        <el-checkbox v-for="user in users" :label="user.username" :key="user.uid">{{user.username}}</el-checkbox>
      </el-checkbox-group>
    </el-form-item>-->

    <el-form-item prop="file">
      <div class="files-upload-list">
        <el-upload
          class="upload-demo"
          drag
          action=""
          :http-request="uploadFile"
          :file-list="simpleForm.newFiles"
          :multiple="false"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">{{$t('feed.settings.common.commonSimpleForm.upload[0]')}} <em>{{$t('feed.settings.common.commonSimpleForm.upload[1]')}}</em></div>
        </el-upload>

        <ul class="files-list" v-if="simpleForm.files.length">
          <li class="files-list__item-title">{{$t('feed.settings.common.commonSimpleForm.uploaded')}}:</li>
          <li class="files-list__item" v-for="file in simpleForm.files" :key="file.link">
          <span class="files-list__item-name">
            {{file.filename}}
          </span>
            <el-link type="primary" icon="el-icon-download" :href="file.link" :underline="false">{{$t('feed.settings.common.commonSimpleForm.download')}}</el-link>
          </li>
        </ul>
      </div>
    </el-form-item>

    <el-button type="primary" @click="submitForm('simpleForm')">Применить</el-button>
  </el-form>
</template>

<script>
  /*
    данные для формы собираются из разных мест
    предварительно в mounted
  */

  // api
  import { getThreadsFilesApi, threadsSaveApi, getThreadUsersApi, setThreadUsersApi, threadSetFiltersAdvanced } from '@/api/feeds';
  import { loadFileApi } from '@/api/files';

  // components
  import notify from "../../../../../../helpers/notify";

  import { GET_USERS, GET_EXT_USERS } from "../../../../../../store/actions/users";
  import { GET_FEEDS } from "../../../../../../store/actions/feeds";

  // vuex
  import { mapGetters } from 'vuex';
  import { iaoApi } from '../../../../../../helpers/iaoApi';

  export default {
    name: 'CommonSimple',
    props: {
      filter: {},
    },
    data() {
      return {
        newUsers: '',
        approxFilter: false,
        changeFilter: false,
        displayUsers: false,
        type: 'keywords',
        simpleForm: {
          name: '',
          show_at_map: false,
          is_strict: false,
          save_for_api: false,
          files: [],
          newFiles: [],
          social: [],
          uid: '',
          username: '',
        },
        usersForm: {
          users: [],
          all: []
        },
        stopFilter: [],
        feed: {},
        social: [
          {
            id: 1,
            name: 'vk',
            label: 'VK',
            checked: false,
          },
          {
            id: 2,
            name: 'tw',
            label: 'TW',
            checked: false,
          },
          {
            id: 3,
            name: 'fb',
            label: 'FB',
            checked: false,
          },
          {
            id: 4,
            name: 'gs',
            label: 'СМИ',
            checked: false,
          },
          {
            id: 5,
            name: 'tg',
            label: 'TG',
            checked: false,
          },
          {
            id: 8,
            name: 'yt',
            label: 'YT',
            checked: false,
          },

          {
            id: 7,
            name: 'inst',
            label: 'Inst',
            checked: false,
          },
          {
            id: 10,
            name: 'ok',
            label: 'ОK',
            checked: false,
          },
          {
            id: 11,
            name: 'dz',
            label: 'Дзен',
            checked: false,
          },
        ],
        socialSelected: [],
        rules: {
          name: [
            { required: true, message: 'Поле не должно быть пустым', trigger: 'blur' },
          ],
        }
      };
    },
    computed: {
      ...mapGetters([
        'isAdmin',
        'extUsers',
      ]),
      changeUsers() {
        let changeUsers = this.extUsers
        changeUsers[this.extUsers.length]= {
          "id": 999999999999,
          "username": "Выбрать пользователя ИС ИАО:",
          disabled: true
        }
        return changeUsers
      },
      activeFeed() {
        return this.$store.getters['feed'](this.$route.params.threadId)
          ?
          this.$store.getters['feed'](this.$route.params.threadId)
          :
          [];
      },
      isKeyWordType() {
        return this.activeFeed.threadtype === this.type;
      },
      emptyFilter: {
        get: function () {
          return this.filter.keywords.filters && this.filter.keywords.filters.length < 2 && this.filter.keywords.filters[0].keyword == ''
        },
      },
      approxyFilter: {
        get: function () {
          return this.filter.keywords.filters[0].approximation == 0 ? true : false
        },
        set: function (newValue) {
          console.log('newValue', newValue);
          this.approxFilter = newValue
        }
      },
      headerTitle() {
        return this.$store.getters['feedTitle'](this.$route.params.threadId)
          ?
            this.$store.getters['feedTitle'](this.$route.params.threadId)
          :
            'Назание ленты';
      },
      feedShowAtMap() {
        return this.$store.getters['feedShowAtMap'](this.$route.params.threadId)
          ?
          this.$store.getters['feedShowAtMap'](this.$route.params.threadId)
          :
          false;
      },
      feedIsStrict() {
        return this.$store.getters['feedIsStrict'](this.$route.params.threadId)
          ?
          this.$store.getters['feedIsStrict'](this.$route.params.threadId)
          :
          false;
      },
      feedUid() {
        return this.$store.getters['feedUid'](this.$route.params.threadId)
          ?
          this.$store.getters['feedUid'](this.$route.params.threadId)
          :
          '';
      },
      feedUsername() {
        return this.$store.getters['feedUsername'](this.$route.params.threadId)
          ?
          this.$store.getters['feedUsername'](this.$route.params.threadId)
          :
          '...';
      },
      networks() {
        return this.$store.getters['feed'](this.$route.params.threadId)
          ?
            this.$store.getters['feed'](this.$route.params.threadId).networks
          :
            [];
      },
      users() {
        return this.$store.getters['users']
      },
    },
    methods: {
      saveSettings() {
        let keywordsData = this.filter.keywords.getData();
          this.saveFilters(keywordsData);
      },
      saveFilters(data) {
        this.$emit('updateParent', this.approxyFilter && !this.changeFilter ? -1 : (this.approxFilter && this.changeFilter) ? -1 : 0
        )
        let params = {
          thread_id: this.$route.params.threadId,
          filter: data.filters.map((item) => {
            return {
              keyword: item.keyword,
              enabled: item.enabled,
              approximation: this.approxyFilter && !this.changeFilter ? -1 : (this.approxFilter && this.changeFilter) ? -1 : 0
            }
          }),
          stopfilter: data.stopkeywords.map((item) => {
            return {
              keyword: item.keyword,
              enabled: item.enabled,
            }
          }),
        };

        threadSetFiltersAdvanced(params).then(() => {
          notify.call(this, this.$t("Настройки изменены"), "success");
        });
      },
      uploadFile(file) {

        let fd = new FormData();
        fd.append('upfile',file.file, file.file.name);
        fd.append('note', 'myfileuploaded');
        fd.append('thread_id', this.$route.params.threadId);

        loadFileApi(fd).then(() => {
          notify.call(this, `Файл ${file.file.name} загружен`, "success");
        }).catch(() => {
          notify.call(this, "Ошибка сервера", "error");
        });
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.saveThread();
          } else {
            notify.call(this, "Неверно заполнена форма", "error");
            return false;
          }
        });
      },
      saveThread() {
        let networks = [];
        this.social.forEach(item => {
          if (this.simpleForm.social.includes(item.name)) {
            networks.push(item.id);
          }
        });

        let usersArr = [];
        this.users.forEach(item => {
          if ( this.usersForm.all.includes(item.username)) {
            usersArr.push(+item.uid);
          }
        });
        let userParams = {
          thread_id: this.$route.params.threadId,
          users: usersArr,
        }

        setThreadUsersApi(userParams).then(() => {
          notify.call(this, "Список пользователей изменен", "success");
          this.$store.dispatch(GET_FEEDS);
        });

        let params = {
          id: this.$route.params.threadId,
          threadname: this.simpleForm.name,
          show_at_map: this.simpleForm.show_at_map,
          is_strict: this.simpleForm.is_strict,
          save_for_api: this.simpleForm.save_for_api,
          uid: iaoApi(),
          inner_uid: this.newUsers.id,
          networks,
        };

        threadsSaveApi(params).then(() => {
          notify.call(this, "Настройки изменены", "success");
        });
      },
      getThreadFiles() {
        this.$nextTick( () => {
          getThreadsFilesApi({thread_id: this.$route.params.threadId}).then((resp) => {
            this.simpleForm = {
              ...this.simpleForm,
              files: resp.data,
            };
          });
        })
      },
      getThreadUsers() {
        this.$nextTick( () => {
          getThreadUsersApi({thread_id: +this.$route.params.threadId}).then((resp) => {
            this.usersForm.users.push(...resp.data)
            this.usersForm.users.map((it)=>{
              this.usersForm.all.push(it.username)
            })
          });
        })
      },
      setSocial() {
        this.social.forEach(item => {
          if (this.networks.includes(item.id)) {
            this.simpleForm.social.push(item.name);
          }
          console.log(this.social)
        });
      },
      setName() {
        this.simpleForm.name = this.headerTitle;
        this.simpleForm.show_at_map = this.feedShowAtMap;
        this.simpleForm.is_strict = this.feedIsStrict;
        this.simpleForm.uid = this.feedUid;
        this.simpleForm.username = this.feedUsername;
        this.simpleForm.save_for_api = this.feedUid == iaoApi().toString() ? true : false;
      },
    },
    mounted() {
      console.log('iaoApi', iaoApi().toString())
      this.setSocial();
      this.setName();
      this.getThreadFiles();
      this.getThreadUsers();
      //this.addUsersForm()

    },
    beforeMount() {
      this.$store.dispatch(GET_USERS)
      this.$store.dispatch(GET_EXT_USERS, { parent_id: iaoApi(), limit: 500 })
    }
  }
</script>

<style>
  .files-upload-list {
    display: flex;
  }
  .files-list {
    padding: 0;
    margin: 0 0 0 20px;
    list-style: none;
    flex-grow: 1;
    font-family: "Roboto", "Arial", sans-serif;
  }
  .files-list__item {
    display: flex;
    justify-content: space-between;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 14px;
    padding: 0 0 10px 0;
    color: #5E6D82;
  }
  .files-list__item-title {
    margin-bottom: 15px;
    font-weight: 500;
  }
@media screen and (max-width: 480px) {
      .el-tabs__nav-scroll {
        overflow-x: auto;
      }
      .el-upload-dragger .el-upload__text {
        font-size: 10px;
      }
      .el-upload-dragger {
        width: 100%;
      }
      .el-form-item__content{
        line-height: unset;
      }
}

  /*.el-form-item button{*/
  /*  position: absolute;*/
  /*  top: -50px;*/
  /*  left: 110px;*/
  /*}*/

</style>
